export default {
  namespaced: true,
  state: {
    auditStateEnum: [
      {label: '待审核', value: 1},
      {label: '已通过', value: 2},
      {label: '已拒绝', value: 3},
    ],
    saleStateEnum: [
      {label: '上线', value: 1},
      {label: '下线', value: 0},
    ],
    orderStateEnum: [
      {label: '申请中', value: 1},
      {label: '申请通过', value: 2},
      {label: '申请拒绝', value: 3},
      {label: '已完成', value: 4},
    ],
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/demand/index.js